import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class MaterialIssueService {
  static getParentTopics(category, issueCategory, fullyLoad = false) { 
    const companyRef = JSON.parse(localStorage.getItem('companyInfo'))?.id;
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_TOPIC
        .replace("<category>", category)
        .replace("<fullyLoad>", fullyLoad)
        .replace("<issueCategory>", issueCategory)
        .replace("<companyRef>", companyRef ?? '')
    );
  }

  static getChildTopics(id) {
    const companyRef = JSON.parse(localStorage.getItem('companyInfo'))?.id;
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_SUB_TOPIC
        .replace("<id>", id)
        .replace("<companyRef>", companyRef ?? '') 
    );
  }

  static addTopic(payload) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.ADD_TOPIC,
      payload
    );
  }

  static updateTopic(payload) {
    return HttpUtil.put(
      API_ROUTES.MATERIAL_ISSUES.UPDATE_TOPIC,
      payload
    );
  }

  static deleteTopic(id, companyRef = null) {
    let url = API_ROUTES.MATERIAL_ISSUES.DELETE_TOPIC.replace("<id>", id);
    if (companyRef) {
      url += `?companyRef=${companyRef}`;
    }
    return HttpUtil.delete(url);
  }

  static searchAllTopics(key = '') {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.SEARCH_TOPICS
        .replace("<name>", key)
    );
  }

  static saveTopicForCompany(payload, category = '') {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.SAVE_FOR_COMPANY.replace("<category>", category),
      payload
    );
  }

  static getAllForCompany(period, companyId, category = '', fullyLoad = true) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_ALL_FOR_COMPANY
        .replace("<period>", period)
        .replace("<companyId>", companyId)
        .replace("<category>", category)
        .replace("<fullyLoad>", fullyLoad)
    );
  }

  static getScoreCard(assessmentId, version) {
    return HttpUtil.get(
      API_ROUTES.SCORE_CARD.GET
        .replace("<assessmentId>", assessmentId)
        .replace("<version>", version)
    );
  }

  static getScoreCardDefault(companyId, year) {
    return HttpUtil.get(
      API_ROUTES.SCORE_CARD.GET_DEFAULT
        .replace("<companyId>", companyId)
        .replace("<year>", year)
    );
  }

  static finalizeForCompany(companyId, year) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.FINALIZE
        .replace("<companyId>", companyId)
        .replace("<year>", year),
      {}
    );
  }

  static getConsolidatedScoreCard(companyId, assessmentId = '') {
    return HttpUtil.get(
      API_ROUTES.SCORE_CARD.GET_CONSOLIDATED
        .replace("<companyId>", companyId)
        .replace(
          assessmentId ? "<assessmentId>" : "&assessmentId=<assessmentId>",
          assessmentId ?? ''
        )
    );
  }

  static getSCVersions(companyId, year) {
    return HttpUtil.get(
      API_ROUTES.SCORE_CARD.GET_SC_VERSIONS
        .replace("<companyId>", companyId)
        .replace("<year>", year)
    );
  }

  static getReportLists(pageSize, pageNumber, companyId, year) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.SCORE_CARD.GET_REPORT_LIST
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace("<companyId>", companyId)
        .replace("<year>", year)
    );
  }

  static genReport(companyId, version, compName) {
    return HttpUtil.post(
      API_ROUTES.SCORE_CARD.GENERATE_REPORT
        .replace("<companyId>", companyId)
        .replace("<version>", version)
        .replace("<compName>", compName), {}
    );
  }

  static saveScoreCardDet(assessmentId, version, companyId, payload) {
    return HttpUtil.post(
      API_ROUTES.SCORE_CARD.SAVE_DATA
        .replace("<assessmentId>", assessmentId)
        .replace("<version>", version)
        .replace("<companyId>", companyId), payload
    );
  }

  static finalizeScoreCardData(assessmentId, version, companyId, graphImg = '', companyName = '') {
    return HttpUtil.patch(
      API_ROUTES.SCORE_CARD.FINALIZE_DATA
        .replace("<assessmentId>", assessmentId)
        .replace("<version>", version)
        .replace("<companyId>", companyId)
        .replace("<graphImg>", graphImg)
        .replace("<company>", companyName)
    );
  }

  static getVersions(companyId, year) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.VERSIONS_LIST
        .replace("<companyId>", companyId)
        .replace("<year>", year)
    );
  }

  static getVersionBasedData(year, companyId, versionId) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_VERSION_BASED
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
    );
  }

  static saveTopicForCompanyNew(payload, category = '', versionId) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.SAVE_FOR_COMPANY_NEW
        .replace("<category>", category)
        .replace("<versionId>", versionId),
      payload
    );
  }

  static finalizeForCompanyNew(companyId, year, versionId, lang, issueCategory) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.FINALIZE_NEW
        .replace("<companyId>", companyId)
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<lang>", lang)
        .replace("<issueCategory>", issueCategory),
      {}
    );
  }

  static getMaterialIssuesCount(year, versionId, companyId, clonedInfoStatus, issueCategory) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_COUNTS
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
        .replace("<clonedInfoStatus>", clonedInfoStatus)
        .replace("<issueCategory>", issueCategory)
    );
  }

  static getSelOmitData(year, versionId, companyId, category, status, issueCategory) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_SEL_OMIT_DATA
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
        .replace("<category>", category)
        .replace("<status>", status)
        .replace("<issueCategory>", issueCategory)
    );
  }

  static saveSelectedData(year, versionId, companyId, topicId, issueCategory, payload) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.SAVE_SELECTED_TOPIC
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
        .replace("<topicId>", topicId)
        .replace("<issueCategory>", issueCategory), payload
    );
  }

  static saveOmittedData(year, versionId, companyId, topicId, masterTopicId, issueCategory, payload) {
    return HttpUtil.post(
      API_ROUTES.MATERIAL_ISSUES.SAVE_OMITTED_TOPIC
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
        .replace("<topicId>", topicId)
        .replace("<masterTopicId>", masterTopicId)
        .replace("<issueCategory>", issueCategory), payload
    );
  }

  static getMaterialIssuesNewDraft(year, versionId, companyId, category, status, issueCategory) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_NEW_DRAFT
        .replace("<year>", year)
        .replace("<versionId>", versionId)
        .replace("<companyId>", companyId)
        .replace("<category>", category)
        .replace("<status>", status)
        .replace("<issueCategory>", issueCategory)
    );
  }

  static updateMateriality(id, issueCategory, payload) {
    return HttpUtil.put(
      API_ROUTES.MATERIAL_ISSUES.UPDATE_MATERIALITY
        .replace("<id>", id)
        .replace("<issueCategory>", issueCategory), payload
    );
  }

  static getLatestIssueVersion(companyId, year, status) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_LATEST_ISSUE_VERSION
        .replace("<companyId>", companyId)
        .replace("<year>", year)
        .replace("<status>", status)
    );
  }

  static getScoreForQuestion(companyId, questionId, groupId) {
    return HttpUtil.get(
      API_ROUTES.SCORE_CARD.GET_SCORE_FOR_QUESTION
        .replace("<companyId>", companyId)
        .replace("<questionId>", questionId)
        .replace("<groupId>", groupId)
    );
  }

  static getMatIssuesCategory() {
    return HttpUtil.get(API_ROUTES.MATERIAL_ISSUES.GET_MATERIAL_ISSUES_CAT);
  }

  static getStats(companyId, year, issueCategory) {
    return HttpUtil.get(
      API_ROUTES.MATERIAL_ISSUES.GET_STATS
        .replace("<companyId>", companyId)
        .replace("<year>", year)
        .replace("<issueCategory>", issueCategory)
    );
  }
}
